import React, { lazy, Suspense } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { RoutePermissionGuard } from '@shared/auth/RoutePermissionGuard';
import { Role } from '@shared/auth/AuthContext';

const PlansPage = lazy(() => import('./modules/plans/pages/PlansPage').then(m => ({ default: m.PlansPage })));
const InvoicesPage = lazy(() => import('./modules/invoices/pages/InvoicesPage').then(m => ({ default: m.InvoicesPage })));
const PurchasesPage = lazy(() => import('./modules/payments/pages/PurchasesPage').then(m => ({ default: m.PurchasesPage })));
const LedgerPage = lazy(() => import('./modules/ledger/pages/LedgerPage').then(m => ({ default: m.LedgerPage })));
const PaymentsPage = lazy(() => import('./modules/payments/pages/PaymentsPage').then(m => ({ default: m.PaymentsPage })));

const LoadingFallback: React.FC = () => (
  <div className="flex h-64 items-center justify-center">
    <div className="h-6 w-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const INVOICE_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'counselor', 'accountant', 'student', 'parent'];
const PLAN_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'counselor', 'accountant'];
const ACCOUNTING_ROLES: Role[] = ['owner', 'admin', 'accountant'];

export const feesRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="invoices" replace />,
  },
  {
    path: 'plans',
    handle: { crumb: 'Fee Structures' },
    element: (
      <RoutePermissionGuard permission="fees.manage" allowedRoles={PLAN_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <PlansPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'invoices',
    handle: { crumb: 'Invoices & Receipts' },
    element: (
      <RoutePermissionGuard permission="fees.read" allowedRoles={INVOICE_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <InvoicesPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'purchases',
    handle: { crumb: 'Course Purchases & Orders' },
    element: (
      <RoutePermissionGuard permission="fees.read" allowedRoles={INVOICE_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <PurchasesPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'ledger',
    handle: { crumb: 'Double-Entry Ledger' },
    element: (
      <RoutePermissionGuard permission="fees.accounting.read" allowedRoles={ACCOUNTING_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <LedgerPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'payments',
    handle: { crumb: 'Gateways & Payments' },
    element: (
      <RoutePermissionGuard permission="fees.accounting.read" allowedRoles={ACCOUNTING_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <PaymentsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
];
